import { render } from "./InnenLeistungenPage.vue?vue&type=template&id=3b68469c"
import script from "./InnenLeistungenPage.vue?vue&type=script&lang=js"
export * from "./InnenLeistungenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__